import './LineChart.css';

import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartOptions,
} from 'chart.js';
import { ILineChartData } from '../../interfaces/type1/ILineChartData';
import { useRealoadOnThemeToogle } from '../hooks/useRealodOnThemeToogle';
import Color from '../../utils/Colors';
import { useColors } from '../hooks/useColors';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


export default function LineChart(props: { Data: ILineChartData }) {

    let fontColor = useRealoadOnThemeToogle();  

    let {getColors} = useColors();


    let getDataSet = () => {

        if(props.Data.DataSets.SeriesGroupFunction)
        {
            let sets = props.Data.DataSets.SeriesGroupFunction();
            return sets.Select(d => 
            {
                let index = 0;

                for(let i = 0; i < sets.length; i++)
                {   
                    if(d.Key == sets[i].Key)
                    {
                        index = i;
                        break;
                    }
                }

                return {
                    datalabels: {
                        display: window.screen.availWidth > 600 && props.Data.ShowQuantity && d.Data.Count() <= 10,
                        color: fontColor,
                        font:
                        {
                            family: 'Oswald'
                        },
                        formatter: function (value: any, item: any) {

                            if (props.Data.QuantityLabelFormatter)
                                return props.Data.QuantityLabelFormatter(d.Data[item.dataIndex]);
                            else
                                return '';
                        }                
                    },
                    label: d.Key,
                    data: d.Data.Select(s => s.Total),
                    borderColor: d.ColorIndex != undefined ? getColors(10)[d.ColorIndex!] : getColors(10)[index],
                    backgroundColor: d.ColorIndex != undefined ? getColors(10)[d.ColorIndex!] : getColors(10)[index],
                    borderWidth: 2,
                    tension: 0.4,
                    pointRadius: window.screen.availWidth > 600 && d.Data.Count() <= 10 ? 5 : 0 ,
                    pointHoverRadius: props.Data.EnableTooltip ? 7 : 5           
                }

            });
        }
        else{
            return [{
            datalabels: {
                display: window.screen.availWidth > 600 && props.Data.ShowQuantity && props.Data.DataSets.Data.Count() <= 10,
                color: fontColor,
                font:
                {
                    family: 'Oswald'
                },
                formatter: function (value: any, item: any) {
                    
                    if (props.Data.QuantityLabelFormatter)
                        return props.Data.QuantityLabelFormatter(props.Data.DataSets.Data[item.dataIndex]);
                    else
                        return '';
                }                
            },
            label: props.Data.DataSets.Title,
            data: props.Data.DataSets.Data.Select(s => s.Total),
            borderColor: getColors(props.Data.DataSets.Data.Count()),
            backgroundColor: getColors(props.Data.DataSets.Data.Count()),
            borderWidth: 2,
            tension: 0.4,
            pointRadius: window.screen.availWidth > 600 && props.Data.DataSets.Data.Count() <= 10 ? 5 : 0 ,
            pointHoverRadius: props.Data.EnableTooltip ? 7 : 5           
        }]
        }
    }


    const data = {
        labels:
            props.Data.LabelFormat ? props.Data.DataSets.Data.Select(s => props.Data.LabelFormat!(s.Group)).Distinct() :
                props.Data.DataSets.Data.Select(s => s.Group).Distinct(),
        datasets: getDataSet(),
    };



    const options: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                anchor: 'start', 
                align: 'left', 
                clip: false, 
                padding: {
                  top: 10,
                  left: -20,
                  bottom: 10,
                },
              },
            tooltip: {
                enabled: props.Data.EnableTooltip ?? true,
                callbacks: {
                    title: (tooltipItems) => {
                        const labelIndex = tooltipItems[0].dataIndex;
                        return data.labels[labelIndex];
                    },
                    label: (tooltipItem) => {
                        
                        const index = tooltipItem.dataIndex;
                        const total = tooltipItem.dataset.data[index];
                        if (props.Data.ToolTipFormatter) 
                        {
                            if(props.Data.DataSets.SeriesGroupFunction)
                            {
                                let sets = props.Data.DataSets.SeriesGroupFunction();

                                let item = sets.find(s => s.Key == tooltipItem.dataset.label);

                                if(item)
                                    return props.Data.ToolTipFormatter(item.Data[tooltipItem.dataIndex]);
                            }
                            return props.Data.ToolTipFormatter(props.Data.DataSets.Data[tooltipItem.dataIndex]);

                        } else {
                            return `Total ${total}`;
                        }


                    }
                },
            },
            legend: {
                display: props.Data.ShowLegend,                
                labels: {
                    color: fontColor,
                    font:
                    {
                        family: 'Oswald'
                    }
                },
            },
            title: {
                display: false,
                text: props.Data.Title,
                color: fontColor,
                font:
                {
                    family: 'Oswald',
                    size: 19

                },
                padding: {
                    bottom: 25
                }

            },
        },
        scales: {
            x: {
                ticks: {
                    color: fontColor,                    
                    font:
                    {
                        family: 'Oswald'
                    }
                },
                grid: {
                    color: 'rgba(255, 255, 255, 0.2)',
                },
            },
            y: {
                ticks: {
                    color: fontColor,
                    callback: function (v: any) {

                        if (props.Data.YTickFormatter)
                            return props.Data.YTickFormatter(v);
                        return `${v}`;
                    },
                    font:
                    {
                        family: 'Oswald'
                    }
                },

                grid: {
                    color: 'rgba(255, 255, 255, 0.2)',
                },
            },
        },
    };

     if (props.Data.XTickFormatter) {
        options.scales!.x!.ticks!.callback = function (v: any) {

            let item = props.Data.DataSets.Data[v];
            let label = item.Group;           
            if (props.Data.XTickFormatter)
                return props.Data.XTickFormatter(item);
            return `${label}`;
        }
    }

    return (
        <div className='LineChartComponent'>
            <Line data={data} options={options} />
        </div>
    );
};

